import React from 'react';
import { User, MapPin, Briefcase, Phone, Mail, UserCheck } from 'lucide-react';
import InputField from './common/InputField';

const BuilderFields = ({ handleInputChange, errors = {} }) => {
    return (
        <>
            <InputField
                label="Developer/Builder Name"
                name="builderName"
                placeholder="Company Name"
                icon={User}
                required
                error={errors.builderName}
                onChange={handleInputChange}
            />

            <InputField
                label="Corporate Office Address"
                name="officeAddress"
                placeholder="Full Address"
                icon={MapPin}
                onChange={handleInputChange}
            />

            <div className="bg-gray-50/50 p-2">
                <div className="text-[10px] font-bold text-tertiary uppercase tracking-wider px-3 py-2">Representative Info</div>

                <InputField
                    label="Name"
                    name="repName"
                    placeholder="Representative Name"
                    icon={UserCheck}
                    onChange={handleInputChange}
                    className="bg-white shadow-sm mb-2"
                />

                <div className="w-full p-4 flex flex-col justify-center text-left bg-white rounded-xl shadow-sm">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1 px-1">
                        Who are you
                    </label>
                    <div className="flex items-center px-1">
                        <Briefcase className="w-4 h-4 text-primary mr-3" />
                        <select
                            name="repRole"
                            className="w-full outline-none font-medium text-darkText bg-transparent text-sm cursor-pointer"
                            onChange={handleInputChange}
                            defaultValue=""
                        >
                            <option value="" disabled className="text-gray-400">Select Role</option>
                            <option value="Broker">Appointed Broker</option>
                            <option value="PMC">Appointed PMC</option>
                            <option value="Employee">Employee</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Contact"
                    name="contact"
                    type="tel"
                    placeholder="Phone Number"
                    icon={Phone}
                    required
                    error={errors.contact}
                    onChange={handleInputChange}
                />

                <InputField
                    label="Mail"
                    name="email"
                    type="email"
                    placeholder="Email Address"
                    icon={Mail}
                    required
                    error={errors.email}
                    onChange={handleInputChange}
                />
            </div>
        </>
    );
};

export default BuilderFields;


